<template>
    <div>
        <b-table
            show-empty
            empty-text="ไม่มีรายละเอียดข้อมูลพื้นที่ร้าน"
            :items="area"
            :fields="fieldsArea"
            responsive
            :busy="busy"
            class="scroll-bar-pop"
        >
            <div slot="table-busy" class="text-center">
                <BlockUI >
                    <div class="loader"></div>
                </BlockUI>
            </div>
            <template slot="thead-top">
                <b-tr>
                    <b-th colspan="3"></b-th>
                    <b-th colspan="2" variant="primary" class="text-center">พื้นที่ว่างเก็บของ</b-th>
                    <b-th></b-th>
                    <b-th colspan="2" variant="primary" class="text-center">พื้นที่ว่างเก็บของให้เช่า</b-th>
                </b-tr>
            </template>
            <template slot="shop_code" slot-scope="row">
                <span>{{row.item.shop_code}}</span><br>
                <span>{{row.item.owner_name}}</span><br>
                <span>{{($THEME.packagePrefix) ? $THEME.packagePrefix[row.item.package] : row.item.package}}</span>
            </template>
            <template slot="storage_space_height" slot-scope="row">
                {{heightBrance(row.item.storage_space_height)}}
            </template>
            <template slot="storage_rent_height" slot-scope="row">
                {{heightBrance(row.item.storage_rent_height)}}
            </template>
            <template slot="storage_rent" slot-scope="row">
                {{rentBrance(row.item.storage_rent)}}
            </template>
            <template slot="billboard_rent" slot-scope="row">
                {{billboardBrance(row.item.billboard_rent)}}
            </template>
            <template slot="kitchen_area" slot-scope="row">
                <span class="text-newline">{{kitchenBrance(row.item.kitchen_area)}}</span>
            </template>
            <template slot="actions" slot-scope="row">
                <button
                    class="btn btn-sm btn-info px-3"
                    @click="$router.push({name:'branceedit',params:{Id:row.item.id}})"
                >แก้ไข</button>
                <button
                    class="btn btn-sm btn-danger px-3"
                    @click="($emit('showComfirmModal',row.item.id))"
                    v-if="auth0RoleUsage('brancemanagedelete')"
                >ลบ</button>
            </template>
        </b-table>
    </div>
</template>
<script>
import { heightBrance , rentBrance , billboardBrance  , kitchenBrance } from "@/plugins/formatForBrance.js";
import { auth0RoleUsage } from "@/helpers/auth0"

export default {
    name:"TableBranceArea",
    props: {
        busy: Boolean,
        area: Array,
    },
    data(){
        return {
            heightBrance: heightBrance,
            rentBrance: rentBrance,
            billboardBrance: billboardBrance,
            kitchenBrance: kitchenBrance,
            auth0RoleUsage: auth0RoleUsage
        }
    },
    computed:{
        fieldsArea(){
            let fields = [
                { key: "last_updated", label: "วันที่อัพเดตข้อมูลล่าสุด", sortable: true },
                { key: "shop_code", label: "ร้าน", sortable: true ,class: 'text-center'},
                { key: "area_shop", label: "พื้นที่ทั้งหมด (ตารางเมตร)", sortable: true ,class: 'text-center'},
                { key: "storage_space_meters", label: "พื้นที่ว่าง (ตารางเมตร)", sortable: true },
                { key: "storage_space_height", label: "ความสูง (เมตร)", sortable: true },
                { key: "storage_rent", label: "พื้นที่ว่างเก็บของให้เช่า", sortable: true },
                { key: "storage_rent_meters", label: "พื้นที่ว่าง (ตารางเมตร)", sortable: true },
                { key: "storage_rent_height", label: "ความสูง (เมตร)", sortable: true },
                { key: "billboard_rent", label: "พื้นที่โฆษณาให้เช่า (กว้าง x ยาว)", sortable: true },
                { key: "kitchen_area", label: "พื้นที่ทำครัว", sortable: true },
                { key: "actions", label: "การจัดการ", sortable: true }
            ]
            return fields
        },
    }
   
}
</script>